export const enum Permission {
  APPLICATIONS = 1,
  ALL_INTERVIEWS = 2,
  MY_INTERVIEWS = 3,
  SCHEDULE = 4,
  RESOURCES = 5,
  ANNOUNCEMENTS = 6,
  DATABASES = 7,
  COMMUNICATIONS = 8,
  TRAINING_CLASSES = 9,
  CONTACT_INFORMATION = 10,
  MAS = 11,
  MAS_ADMIN = 12,
  STAFFING = 13,
  REPORTING = 14,
  TRAINER = 15,
  CREATE_GIG = 16,
  APPLICATION_HISTORY = 17,
  BLOCK_USER = 18,
  PERMISSION = 19,
}

export const enum PermissionLevel {
  VIEW = 1,
  MODIFY = 2,
  ANY = 3,
}
